<div
  class="waitlist-overlay"
  *ngIf="isVisible"
  (click)="onBackdropClick($event)"
>
  <div class="flex flex-column justify-content-center p-4">
    <img *ngIf="content.imageSrc" class="max-h-18rem" style="object-fit: contain;" [src]="content.imageSrc"
      alt="hero-image"   [ngClass]="{ 'entry-mode': mode === WaitlistMode.entry }"
    />
    <h3 class="text-center mb-3" [innerHTML]="content.title"></h3>
    <p class="mb-3 text-900 text-center">{{ content.message }}</p>
    <button class="action-btn justify-content-center mb-4 md:mb-0" pButton severity="secondary" (click)="onAction()">
      {{ content.buttonText }}
    </button>
  </div>
</div>
